import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-button',
  standalone: true,
  imports: [CommonModule],
  template: ` <button
    (click)="$event.stopPropagation(); click.emit($event)"
    [ngClass]="['btn btn-' + color + ' text-' + colorForText]"
    class="{{ class }}"
    [disabled]="disabled"
  >
    {{ label }}
    @if (icon) {
      @if (translate.currentLang === 'ar') {
        <i class="pi pi-chevron-left"></i>
      } @else {
        <i class="pi pi-chevron-right"></i>
      }
    }
  </button>`,
  styleUrls: ['./app-button.component.scss']
})
export class AppButtonComponent {
  translate: TranslateService = inject(TranslateService);

  @Input() label!: string;
  @Input() colorForText!: string;
  @Input() color!: 'primary' | 'outline-primary' | 'secondary' | 'outline-secondary';
  @Input() class!: string;
  @Input() disabled!: boolean;
  @Input() icon!: boolean;
  @Output() click = new EventEmitter<MouseEvent>();
}
